import React from 'react'

const ProfilePage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold mb-6">Profile</h1>
      <p>Manage your profile and view your betting history.</p>
    </div>
  )
}

export default ProfilePage